/* ============================================================
   pass.js — what a token says, read in the room (pure; scripts/listen.test.mjs).

   The access token is a JWT: its subject keys this browser's memory of an account (seen, rides), its expiry
   is the pass-link station's card line. Nothing here touches the network or the DOM.
   ============================================================ */
export const jwtClaims = (token) => {
  try {
    return JSON.parse(atob(String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))) || {};
  } catch {
    return {};
  }
};
export const jwtSub = (token) => jwtClaims(token).sub || '';

/* the card's second line on the pass-link station. The year rides along once the date is not obviously this year (a
   12-month tester pass read "until Sep 10" and looked like it expired last week — real token, 2026-09-16); inside the
   year, the bare month + day is the friendlier line. */
export const passUntil = (token, now = new Date()) => {
  const exp = jwtClaims(token).exp;
  if (!exp) return 'pass';
  const d = new Date(exp * 1000);
  const far = d.getFullYear() !== now.getFullYear();
  return `pass · until ${d.toLocaleDateString([], far ? { year: 'numeric', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' })}`;
};

/* a first night, for a pass: the first time this token's subject enters on this browser (Google has the server's is_new) */
export const SEEN = (sub) => `miya.listen.seen.${sub}`;
export const firstTimeHere = (sub, storage = globalThis.localStorage) => {
  if (!sub) return false;
  try {
    if (storage.getItem(SEEN(sub)) === '1') return false;
    storage.setItem(SEEN(sub), '1');
    return true;
  } catch {
    return false;
  }
};
